import { ref } from 'vue'
import { defineStore } from 'pinia'

export const useLangStore = defineStore('lang', () => {

    const lang = ref('RU')

    function setLang(payload) {

        localStorage.setItem('UTA_LANG', payload)
        lang.value = payload
    }

    return {

        lang,
        setLang
    }
})